"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PProgramObjTreeList_1 = require("./controls/PProgramObjTreeList");
var PProgramAreaRoot_1 = require("./controls/PProgramAreaRoot");
var PProgramAreaDir_1 = require("./controls/PProgramAreaDir");
var PProgramAreaImg_1 = require("./controls/PProgramAreaImg");
var PProgramImageContentList = /** @class */ (function (_super) {
    __extends(PProgramImageContentList, _super);
    function PProgramImageContentList(props) {
        return _super.call(this, props) || this;
    }
    PProgramImageContentList.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            areaRenderMode: "none"
        }, function () {
            _this.props.ctxData.LoadData();
        });
    };
    PProgramImageContentList.prototype.onRootNodeSelect = function (key) {
        this.setState({
            areaRenderMode: "root",
            brandKey: key,
            dirKey: ""
        });
    };
    PProgramImageContentList.prototype.onDirNodeSelect = function (bKey, dKey) {
        this.setState({
            areaRenderMode: "dir",
            brandKey: bKey,
            dirKey: dKey
        });
    };
    PProgramImageContentList.prototype.onDirItemSelect = function (bKey, dKey) {
        this.setState({
            areaRenderMode: "dir",
            brandKey: bKey,
            dirKey: dKey
        });
    };
    PProgramImageContentList.prototype.goBackToDirListClick = function (brandId) {
        this.setState({
            areaRenderMode: "root",
            brandKey: brandId,
            dirKey: ""
        });
    };
    PProgramImageContentList.prototype.selectImageClick = function (brandId, dirName, fileName) {
        if (this.props.onSelectImage) {
            this.props.onSelectImage(this.props.ctxData.getPProgramItemById(brandId).identity, dirName, fileName);
        }
    };
    PProgramImageContentList.prototype.getRenderArea = function () {
        if (this.state.areaRenderMode === "none") {
            return (React.createElement(PProgramAreaRoot_1.default, null));
        }
        if (this.state.areaRenderMode === "root") {
            return (React.createElement(PProgramAreaDir_1.default, { data: this.props.ctxData, brandId: this.state.brandKey, onSelectDirectory: this.onDirItemSelect.bind(this) }));
        }
        if (this.state.areaRenderMode === "dir") {
            return (React.createElement(PProgramAreaImg_1.default, { data: this.props.ctxData, brandId: this.state.brandKey, dirName: this.state.dirKey, onGoBackClick: this.goBackToDirListClick.bind(this), onSelectImage: this.selectImageClick.bind(this) }));
        }
        return null;
    };
    PProgramImageContentList.prototype.render = function () {
        return (React.createElement("div", { style: { height: "500px", width: "750px" } },
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "flex-start",
                    height: "100%"
                } },
                React.createElement(PProgramObjTreeList_1.default, { data: this.props.ctxData, onSelectRootNode: this.onRootNodeSelect.bind(this), onSelectDirNode: this.onDirNodeSelect.bind(this), selectedBrandId: this.state.brandKey, selectedDirName: this.state.dirKey, forceSelectDirMode: this.state.areaRenderMode }),
                this.getRenderArea())));
    };
    return PProgramImageContentList;
}(React.Component));
exports.default = PProgramImageContentList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/dlgSelectPProgramImage/PProgramImageContentList.tsx
// module id = 2470
// module chunks = 0